export default {"src":"/_next/static/media/ico2.a93acc55.svg","height":39,"width":41,"blurWidth":0,"blurHeight":0};